import { type FC, useMemo, useState } from 'react';
import { Wrench } from 'lucide-react';

import type { AlertReset } from '@/alerts/entities/alert-reset';
import { useCurrentAsset } from '@/hooks/use-current-asset';
import { label } from '@/utils/format/label';

import { AlertResetsModal } from './alert-resets-modal';

export type AlertResetsBannerProps = {
  alertResets: AlertReset[];
};

export const AlertResetsBanner: FC<AlertResetsBannerProps> = ({
  alertResets,
}) => {
  const [showResetModal, setShowResetModal] = useState(false);
  const { assetId } = useCurrentAsset();

  // Filter alert resets for the current asset
  const filteredAlertResets = useMemo(() => {
    if (!alertResets) return [];
    if (!assetId) return alertResets;
    return alertResets.filter((reset) => reset.systemFrontendId === assetId);
  }, [alertResets, assetId]);

  if (!filteredAlertResets?.length) {
    return null;
  }

  return (
    <>
      <div className="border-b border-gray-200 bg-gray-50 px-6 py-4">
        <div className="flex items-start gap-2 text-sm">
          <Wrench className="mt-0.5 size-4 text-primary-700" />
          <span className="text-gray-700">
            <button
              className="font-semibold text-primary-700 hover:text-primary-500 hover:underline"
              onClick={() => setShowResetModal(true)}
            >
              {filteredAlertResets.length}{' '}
              {label(['Alert', 'Alerts'], filteredAlertResets.length)}
            </button>{' '}
            reset due to maintenance.
          </span>
        </div>
      </div>

      <AlertResetsModal
        isOpen={showResetModal}
        onClose={() => setShowResetModal(false)}
        alertResets={filteredAlertResets}
      />
    </>
  );
};
